import script from "./CourtPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtPayment.vue?vue&type=script&setup=true&lang=js"

import "./CourtPayment.vue?vue&type=style&index=0&id=7376a4a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7376a4a0"]])

export default __exports__